<script setup>
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { RouterLink, useRoute, useRouter } from "vue-router";

import VocabService from "@/common/api/vocab.service";
import IconLogout from "@/components/icons/IconLogout.vue";
import LogoAbc from "@/components/logo/LogoAbc.vue";
import { useAuthStore } from "@/stores";

const authStore = useAuthStore();
const router = useRouter();
const { params: routeParams } = useRoute();
const { t } = useI18n();

const { userIsTeacher } = storeToRefs(authStore);

const endQuiz = async () => {
  try {
    await VocabService.endClassQuiz(routeParams.quizCode);
  } catch (error) {
    // Gracefully catch error
  }

  router.push({ name: "vocab.home" });
};
</script>

<template>
  <div class="app-layout">
    <header class="header">
      <div class="container-lg">
        <div class="header__group row">
          <div class="col d-flex align-items-center justify-content-lg-start">
            <span class="site-logo">
              <LogoAbc role="presentation" />
            </span>
          </div>
          <div class="col header__end-container position-static">
            <div
              class="header__group-container header__item-group d-flex align-items-center justify-content-end"
            >
              <button
                v-if="userIsTeacher"
                class="app-layout__vocab-header-exit header__item"
                @click="endQuiz()"
              >
                <IconLogout role="presentation" class="app-layout__vocab-header-exit-icon" />
                <span>{{ t("vocab.header.finishQuiz") }}</span>
              </button>
              <RouterLink
                v-else
                :to="{
                  name: 'vocab.list',
                  params: { shareCode: routeParams.shareCode }
                }"
                class="app-layout__vocab-header-exit header__item"
              >
                <IconLogout role="presentation" class="app-layout__vocab-header-exit-icon" />
                <span>{{ t("vocab.header.finishQuiz") }}</span>
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="app-layout__view">
      <slot />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.app-layout {
  touch-action: manipulation;
}

.app-layout__vocab-header {
  &-exit {
    display: flex;
    align-items: center;
    border: none;
    background: none;
    gap: 9px;
    color: rgb(@theme-colors[@grey][110]);

    &-icon {
      color: rgb(@theme-colors[@red][base]);
    }
  }
}

.site-logo-icon {
  height: 20px;

  #media-breakpoint-up(md, {
    height: 25px;
  });
}
</style>
